export enum Role {
	LEARNER = 1,
	INSTRUCTOR = 2,
	GUARDIAN = 3,
	SCHOOL_OFFICIAL = 4,
	EMPLOYEE = 5,
	ADMIN = 6
}
